module.exports = __webpack_public_path__ + "img/dislike.7b1b0555.svg";